import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchFeaturedBrandsAPI } from "./featuredBrandsAPI";

export const fetchFeaturedBrandsData = createAsyncThunk(
    "home/fetchFeaturedBrandsData",
    async () => {
        const data = await fetchFeaturedBrandsAPI();
        return data
    }
)

const featuredBrandsSlice = createSlice({
    name: "featuredBrands",
    initialState: {
        brands: [],
        loading: false,
        error: null
    },

    reducers: {},

    extraReducers: (builder) => {
        builder
        .addCase(fetchFeaturedBrandsData.pending, (state) => {
            state.loading = true;
        })
        .addCase(fetchFeaturedBrandsData.fulfilled, (state, action) => {
            state.loading = false;
            state.brands = action.payload.featured_brands || [];
        })
        .addCase(fetchFeaturedBrandsData.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        })
    }
})

export default featuredBrandsSlice.reducer;